import { useState, ReactElement } from 'react';
import Tab from './Tab';
import ReactGA from "react-ga4";

const Tabs = (props: { children: ReactElement[] }) => {
    const [activeTab, setActiveTab] = useState<string>(props.children[0].props.name);

    const filteredChildren = props.children.filter(child => {
        if (child.type !== Tab) {
            console.error("Tabs component contained child that was not a Tab. Tabs should only include Tab!");
            return false;
        }
        if(child.props.hidden) {
            console.warn(`Tab ${child.props.name} is hidden. Is this intentional?`)
            return false;
        }
        return true;
    });

    return (
        <div className="TabContainer">
            <div className="tabsBar">
                {filteredChildren.map((child) => (
                    <button
                        key={child.props.name}
                        onClick={
                            () => {
                                setActiveTab(child.props.name);
                                ReactGA.event({
                                    category: "nav",
                                    action: "goto_tab_" + child.props.name,
                                  });
                            }
                        }
                        className={(activeTab === child.props.name) ? 'active' : ''}
                    >
                        {child.props.name}
                    </button>
                ))}
            </div>
            <div className="tabContent">
                <h1>{activeTab}</h1>
                {filteredChildren.map((child) => {
                    if (child.props.name === activeTab) {
                        return <div key={child.props.name}>{child.props.children}</div>;
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

export default Tabs;
